import { render, staticRenderFns } from "./GuestFormShell.vue?vue&type=template&id=8fb5ee60&"
import script from "./GuestFormShell.vue?vue&type=script&lang=ts&"
export * from "./GuestFormShell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports